import { APP_BASE_HREF, registerLocaleData } from '@angular/common';
import { MomentDatePipe } from 'app/shared/pipe/moment.pipe';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import localeEs from '@angular/common/locales/es';
import locale from '@angular/common/locales/it';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { NgbDateAdapter, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule, TranslatePipe, TranslateService } from '@ngx-translate/core';
import { OAuthModule } from 'angular-oauth2-oidc';
import { AuthExpiredInterceptor } from 'app/blocks/interceptor/auth-expired.interceptor';
import { AuthInterceptor } from 'app/blocks/interceptor/auth.interceptor';
import { ErrorHandlerInterceptor } from 'app/blocks/interceptor/errorhandler.interceptor';
import { NgbDateMomentAdapter } from 'app/shared/util/datepicker-adapter';
import * as moment from 'moment'; // NOSONAR: This import is necessary for moment usage. Default import doesn't work.
import { CookieService } from 'ngx-cookie-service';
import { NgxWebstorageModule } from 'ngx-webstorage';

import { AuthServerProvider } from './auth/auth-jwt.service';
import { fontAwesomeIconsFinal } from './icons/font-awesome-icons';
import { AppConfiguration } from './models/app-configuration.model';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Router } from '@angular/router';

/* browser language */
type CustomNavigator = Navigator & { userLanguage: string; }
let toSplit = 'en';
if ((navigator as CustomNavigator).userLanguage) {
  toSplit = (navigator as CustomNavigator).userLanguage;
} else {
  toSplit = navigator.language;
}
export const navigatorLanguage = toSplit.split('-').shift();

export function createTranslateLoader(http: HttpClient, _router: Router) {
  return new TranslateHttpLoader(http, 'content/i18n/', '.json');
}

const CENTURY = 100;

/**
 * Angular Core module
 * define language configuration, http interceptor and oauth configuration
 */
@NgModule({
  imports: [
    HttpClientModule,
    NgxWebstorageModule.forRoot({ prefix: 'ap', separator: '-' }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient, Router],
      },
    }),
    OAuthModule.forRoot(),
  ],
  providers: [
    Title,
    CookieService,
    {
      provide: LOCALE_ID,
      useValue: navigatorLanguage,
    },
    { provide: NgbDateAdapter, useClass: NgbDateMomentAdapter },
    MomentDatePipe,
    TranslatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthExpiredInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (initialAuthService: AuthServerProvider) => () => initialAuthService.initAuth(),
      deps: [AuthServerProvider],
      multi: true,
    },
    {
      provide: APP_BASE_HREF,
      useFactory: (config: AppConfiguration) => config.baseHref,
      deps: [AppConfiguration],
    },
  ],
})
export class AccountPanelCoreModule {
  constructor(iconLibrary: FaIconLibrary, dpConfig: NgbDatepickerConfig, languageService: TranslateService) {
    registerLocaleData(locale);
    registerLocaleData(localeEs);
    iconLibrary.addIcons(...fontAwesomeIconsFinal);
    dpConfig.minDate = { year: moment().year() - CENTURY, month: 1, day: 1 };
    languageService.use(navigatorLanguage ?? 'it');
    languageService.setDefaultLang('it');
  }
}
